import { chromelessLayout } from '@atlassian/jira-chromeless-layout/src/index.tsx';
import { createChromelessEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { ThemedLazySkeleton } from '@atlassian/jira-project-theme-components/src/ui/ThemedLazySkeleton.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getProjectViewResources } from '@atlassian/jira-router-resources-business-common/src/index.tsx';
import { jiraBusinessTimelineEmbedRoute } from '@atlassian/jira-router-routes-business-timeline-routes/src/jiraBusinessTimelineEmbedRoute.tsx';
import { timelineEmbedEntrypoint } from '@atlassian/jira-spa-apps-business-timeline-embed/entrypoint.tsx';
import { timelineEntrypoint } from '@atlassian/jira-spa-apps-harmonised-business-timeline/entrypoint.tsx';

const timelineEmbedPageEntrypoint = createChromelessEntryPoint({
	main: timelineEntrypoint,
});

const legacyimelineEmbedPageEntrypoint = createChromelessEntryPoint({
	main: timelineEmbedEntrypoint,
});

export const jiraBusinessTimelineEmbedRouteEntry = createEntry(
	jiraBusinessTimelineEmbedRoute,
	() => ({
		group: 'classic-business',
		ufoName: 'jwm.timeline-embed-view',
		layout: chromelessLayout,
		skeleton: ThemedLazySkeleton,
		resources: getProjectViewResources(),

		entryPoint: () =>
			// eslint-disable-next-line jira/ff/no-preconditioning
			fg('enable_field_namespace_filtering') &&
			fg('issue_table_frozen_columns') &&
			fg('jira_list_extended_scroll_container_props') &&
			fg('jira_list_merged_column_gate') &&
			fg('jira_native_issue_table_extra_custom_components') &&
			fg('jira_harmonised_business_timeline_embed')
				? timelineEmbedPageEntrypoint
				: legacyimelineEmbedPageEntrypoint,

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-business-timeline-entries/src/jiraBusinessTimelineEmbedRouteEntry.tsx',
				whichExportToUse: 'jiraBusinessTimelineEmbedRouteEntry',
			},

			enabled: true,
		},
	}),
);
